<div *ngIf="this.username != null && this.impersonatedEmail != null && this.roleName != null" class="floating-banner">
  <div>
    <table class="floating-banner-table">
      <thead>
        <tr>
          <th style="width:80%">
            <span class="webtext-white">
                You are viewing {{this.impersonatedEmail}} as a <b><u>{{this.roleName}}</u></b>.
            </span>
          </th>
          <th style="width:20%">
            <app-st-button-cancel [idVal]="'top-cancel-button-id'" [label]="'Exit'" [primary]="false"
                                  (click)="this.onExitViewAs()"></app-st-button-cancel>
          </th>
        </tr>
      </thead>
    </table>
  </div>
</div>
